import { ReportFieldFlag, ReportFieldType } from '../../../../models'

interface ReportFieldConfig {
    showName?: boolean,
    showTableColumns?: boolean,
    showOptions?: boolean,
    showDescription?: boolean,
    showMandatoryCombo?: boolean,
    showDefaultValue?: boolean,
    showHelpNotes?: boolean,
    showFlags?: boolean,
    showFontSize?: boolean,
    showHeight?: boolean,
    showImageMarker?: boolean,
    largeEdition?: boolean,
    autoLabel?: boolean,
    autoFlags?: ReportFieldFlag[],
}

export const reportFieldModalConfig: Record<ReportFieldType , ReportFieldConfig> = {
    [ReportFieldType.Text]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
        showFontSize: true,
    },
    [ReportFieldType.MultilineText]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
        showFontSize: true,
        largeEdition: true,
        showHeight: true,
    },
    [ReportFieldType.IntNumber]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true, 
        showFontSize: true,
    },
    [ReportFieldType.FloatNumber]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
        showFontSize: true,
    },
    [ReportFieldType.Date]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
        showFontSize: true,
    },
    [ReportFieldType.ImageMarker]: {
       showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showHelpNotes: true,
        showFlags: true,
        showImageMarker: true,
        showHeight: true,
    },
    [ReportFieldType.Separator]: {
        autoLabel: true,
        autoFlags: [ReportFieldFlag.HideLabel],
    },
    [ReportFieldType.BlankSpace]:  {
        autoLabel: true,
        autoFlags: [ReportFieldFlag.HideLabel],
        showHeight: true,
    },
    [ReportFieldType.Scale]: {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
    },
    [ReportFieldType.MultiOptions]: {
        showName: true,
        showOptions: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
    },
    [ReportFieldType.Table]: {
        showName: true,
        showTableColumns: true,
        showOptions: true,
        showDescription: true,
        showMandatoryCombo: true,
        showDefaultValue: true,
        showHelpNotes: true,
        showFlags: true,
        largeEdition: true,
    },
    [ReportFieldType.Signature]:  {
        showName: true,
        showDescription: true,
        showMandatoryCombo: true,
        showHelpNotes: true,
        showFlags: true,
        autoFlags: [ReportFieldFlag.AlignRight],
        showHeight: true,
    },
}